import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import dayjs from 'dayjs';
@Component({
  selector: 'app-calendar-modal',
  templateUrl: './calendar-modal.component.html',
  styleUrls: ['./calendar-modal.component.css']
})
export class CalendarModalComponent implements OnInit {
  @Input() expiryDate: string = ''
  @Output() dateEmit = new EventEmitter<any>()
  @Output() calendarEmit = new EventEmitter<boolean>()
  @Input() keepCalendarOpeningWithRange: boolean = false;
  @Input() singleDatePicker: boolean = false;
  @Input() timePicker24Hour: boolean = false;
  @Input() showCancel: boolean = false;
  @Input() showClearButton: boolean = false;
  //calendar
  selectedRangeCalendarCenter: any
  dropsDown = 'down';
  dropsUp = 'up';
  opensRight = 'right';
  opensCenter = 'center';
  opensLeft = 'left';
  locale = {
    firstDay: 1,
    startDate: dayjs().startOf('day'),
    endDate: dayjs().endOf('day'),
    customRangeLabel: 'Custom range',
    format: 'DD/MM/YYYY HH:mm:ss a',
    displayFormat: "DD MMMM YYYY HH:mm",
    applyLabel: 'Apply',
    cancelLabel: 'Clear',
    fromLabel: 'From',
    toLabel: 'To',
  };
  @Input() timePicker: boolean = false;
  showDates = {
    minDate: dayjs(),
    maxDate: dayjs(),
  }

  ngOnInit(): void {
    const now = dayjs();
    const expiry = dayjs(this.expiryDate);
    this.showDates.minDate = expiry.isValid() && expiry.isAfter(now) ? expiry : now;
  }

  /**
 * Dates convert
 * @param date 
 * @returns  
 */
  dateConvert(date: any) {
    return dayjs(date).format('MM-DD-YYYY HH:mm')
  }
  /**
   * Clears clicked
   * @param event 
   */
  clearClicked(isClicked: any) {
    this.calendarEmit.emit(isClicked)
  }

  invalidDates: dayjs.Dayjs[] = [];
  isInvalidDate = (m: dayjs.Dayjs) => {
    return this.invalidDates.some((d) => d.isSame(m, 'day'));
  };

  isCustomDate = (date: dayjs.Dayjs) => {
    return date.month() === 0 || date.month() === 6 ? 'mycustomdate' : false;
  };
  /**
 * Dates updated range
 * @param event 
 */
  startDate: string = ''
  endDate: string = ''
  datesUpdatedRange(event: any) {
    const { startDate, endDate } = event
    if (startDate && endDate) {
      this.startDate = this.dateConvert(startDate.$d) as string;
      this.endDate = this.dateConvert(endDate.$d) as string;
      this.dateEmit.emit(this.endDate)
    }
  }

  /**
   * Calenders clear events
   * @param picker 
   */
  calenderClearEvents(picker: any) {
    this.startDate = '';
    this.endDate = '';
    this.dateEmit.emit('');
    picker.hide();
  }

}
